import React, { useEffect, useState } from "react";
import { doc, updateDoc, addDoc, collection } from "firebase/firestore";
import { db } from "firebase.js";

const ManualLocationRankingLinker = ({ user, locationId, unlinkedRankings }) => {
  const [rankings, setRankings] = useState(unlinkedRankings || []);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRanking, setSelectedRanking] = useState(null);
  const [manualRanking, setManualRanking] = useState("");
  const [createNew, setCreateNew] = useState(false);

  useEffect(() => {
    const term = searchTerm.toLowerCase().trim();
    if (term.length < 2) {
      setSelectedRanking(null);
      return;
    }

    const match = rankings.find((r) =>
      r.playerName.toLowerCase().includes(term)
    );
    setSelectedRanking(match || null);
  }, [searchTerm, rankings]);

  if (!user) {
    return <div className="text-white p-4">Aucun utilisateur sélectionné.</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const parsedRanking = parseInt(manualRanking, 10);

    try {
      if (createNew) {
        if (isNaN(parsedRanking)) {
          alert("Classement requis pour création.");
          return;
        }

        await addDoc(collection(db, "locationRankings"), {
          userId: user.id,
          playerName: user.name,
          locationId,
          ranking: parsedRanking,
        });

      } else if (selectedRanking) {
        await updateDoc(doc(db, "locationRankings", selectedRanking.id), {
          userId: user.id,
        });

      } else {
        alert("Veuillez sélectionner un joueur ou cocher pour créer un classement.");
        return;
      }

      window.location.reload(); // ✅ reload page after save
    } catch (error) {
      console.error("Erreur :", error);
      alert("Échec de l'enregistrement.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-6 bg-gray-800 text-white p-6 rounded shadow max-w-xl mx-auto"
    >
      <h3 className="text-xl font-bold text-green-500">{user.name}</h3>

      <div>
        <label className="block font-semibold mb-1">Rechercher un classement sans ID :</label>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Nom dans le classement"
          className="w-full bg-gray-700 border border-gray-600 p-2 rounded"
          disabled={createNew}
        />
        {selectedRanking && !createNew && (
          <p className="text-green-400 mt-2">
            ➕ Sera associé à: <strong>{selectedRanking.playerName}</strong>
          </p>
        )}
      </div>

      <div className="flex items-center space-x-3">
        <input
          type="checkbox"
          checked={createNew}
          onChange={() => {
            setCreateNew(!createNew);
            setSelectedRanking(null);
            setSearchTerm("");
          }}
          className="form-checkbox h-5 w-5 text-amber-500"
        />
        <label className="font-medium text-lg">Créer un nouveau classement</label>
      </div>

      {createNew && (
        <div>
          <label className="block mb-1 font-semibold">Classement :</label>
          <input
            type="number"
            value={manualRanking}
            onChange={(e) => setManualRanking(e.target.value)}
            required
            className="w-full bg-gray-700 border border-gray-600 p-2 rounded"
          />
        </div>
      )}

      <button
        type="submit"
        className="w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold px-4 py-2 rounded"
      >
        Enregistrer
      </button>
    </form>
  );
};

export default ManualLocationRankingLinker;
